class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.onOverlayClick = this.close.bind(this);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindOverlayClick();
    this.setHeaderCartIconAccessibility();
  }

  bindOverlayClick() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (!overlay) return;

    overlay.removeEventListener('click', this.onOverlayClick);
    overlay.addEventListener('click', this.onOverlayClick);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || cartLink.dataset.cartDrawerBound === 'true') return;

    cartLink.dataset.cartDrawerBound = 'true';
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-expanded', 'false');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'SPACE' && event.code.toUpperCase() !== 'ENTER') return;

      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
      this.updateHeaderCartIconExpandedState(true);
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        if (containerToTrapFocusOn && focusElement) trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    this.updateHeaderCartIconExpandedState(false);
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  updateHeaderCartIconExpandedState(isExpanded) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) drawerInner.classList.remove('is-empty');

    this.productId = parsedState.id;

    if (!parsedState.sections) return;

    this.getSectionsToRender()
      .filter((s) => !s.selector)
      .forEach((section) => {
        const el = document.getElementById(section.id);
        if (el && parsedState.sections[section.id]) {
          el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
        }
      });

    requestAnimationFrame(() => {
      this.getSectionsToRender()
        .filter((s) => s.selector)
        .forEach((section) => {
          const el = document.querySelector(section.selector);
          if (el && parsedState.sections[section.id]) {
            el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }
        });

      this.dispatchEvent(
        new CustomEvent('norte:cart-drawer:render', {
          bubbles: true,
          detail: {
            cart: parsedState,
          },
        })
      );

      this.bindOverlayClick();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const section = this.getSectionDOM(html, selector);
    return section ? section.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}